import axios, { AxiosResponse } from 'axios'
import { invertMapKeysAndValues } from './invertMapKeys'
import { AuthHeaders, AuthResponse, DeviceStorage, SingleLayerStringMap } from '../types/auth.types'
import Cookies from 'js-cookie'

export const authHeaderKeys: Array<string> = ['access-token', 'token-type', 'client', 'expiry', 'uid']

export interface CustomAxiosResponse<T = any> extends AxiosResponse<T> {
  headers: AxiosResponse['headers'] & AuthHeaders // Merge default headers with AuthHeaders
}

export const setAuthHeaders = (headers: AuthHeaders): void => {
  authHeaderKeys.forEach((key: string) => {
    axios.defaults.headers.common[key] = headers[key as keyof AuthHeaders]
  })
}

export const persistAuthHeadersInDeviceStorage = (Storage: DeviceStorage, headers: AuthHeaders): void => {
  authHeaderKeys.forEach((key: string) => {
    Storage.setItem(key, headers[key as keyof AuthHeaders])
  })
}

export const persistAuthHeadersInDeviceCookies = (headers: AuthHeaders): void => {
  authHeaderKeys.forEach((key: string) => {
    Cookies.set(key, headers[key as keyof AuthHeaders])
  })
}

export const deleteAuthHeaders = (): void => {
  authHeaderKeys.forEach((key: string) => {
    delete axios.defaults.headers.common[key]
  })
}

export const deleteAuthHeadersFromDeviceStorage = async (Storage: DeviceStorage): Promise<void> => {
  authHeaderKeys.forEach((key: string) => {
    Storage.removeItem(key)
  })
}

export const deleteAuthHeadersFromDeviceCookies = async (): Promise<void> => {
  authHeaderKeys.forEach((key: string) => {
    Cookies.remove(key)
  })
}

export const getUserAttributesFromResponse = (
  userAttributes: SingleLayerStringMap,
  response: AuthResponse
): SingleLayerStringMap => {
  const invertedUserAttributes: SingleLayerStringMap = invertMapKeysAndValues(userAttributes)
  const userAttributesBackendKeys: string[] = Object.keys(invertedUserAttributes)
  const userAttributesToReturn: SingleLayerStringMap = {}
  Object.keys(response.data.data).forEach((key: string) => {
    if (userAttributesBackendKeys.indexOf(key) !== -1) {
      userAttributesToReturn[invertedUserAttributes[key]] = response.data.data[key]
    }
  })
  return userAttributesToReturn
}
